//----------------------------------- On load variant picker list append
$(document).ready(function() {
  function updateURL(hashValue) {
        if (history.pushState) {
            history.pushState(null, null, '#' + hashValue);
          // console.log(hashValue + ' hashvalue');
        } else {
            window.location.hash = hashValue;
          
        }
    }

    function handleNavClick() {
        $('.navbarhighlights_list .navbarhighlights__item .main-content').on('click', function () {
            var clickedText = $(this).text().trim().toLowerCase().replace(/\s+/g, '-');
            updateURL('top-5-' + clickedText);
        });
    }

    function triggerMatchingNavItem() {
        var urlParts = window.location.hash
            .substring(1)
            .trim()
            .toLowerCase()
            .replace(/^top-5-/, '')  
            .replace(/-/g, ' ');

        if (!urlParts) return;

        var navItems = $('.navbarhighlights_list .navbarhighlights__item .main-content');
        navItems.each(function () {
            var navValue = $(this).text().trim().toLowerCase();
            if (navValue === urlParts) { 
                $(this).trigger('click');
                return false; 
            }
        });
    }

    handleNavClick();  
    triggerMatchingNavItem(); 
  $('.swatch-list-navbar-jtpl .swatch-navbar_varaint-jtpl.variant_list_active').each(function() {
    var $this = $(this);
    var initialHtmlContent = $this.html();
    $this.closest('.swatch-grid-color-wrapper-main').find('.selected-swatch-navbar .swatch-selected-color-navbar').each(function() {
      $(this).find('li').each(function() {
        $(this).html(initialHtmlContent);
      });
    });
  });
});

//----------------------------------- Click for selected variant picker
$("body").on("click", ".navbarhighlights__previews-jtpl .selected-swatch-navbar", function() {
  var $this = $(this);  
  var variant_swatch = $this.closest('.swatch-grid-color-wrapper-main').find('.swatch-list-navbar-jtpl');
  // var variant_mains = $('.navbarhighlights__previews-jtpl').find('ul.swatch-selected-color-navbar').removeClass('ul-active');
  var variant_main = $this.find('ul.swatch-selected-color-navbar').toggleClass('ul-active');
  variant_swatch.toggleClass('variant_active');
});

//------------------------------------ Click for selected variant picker List
$("body").on("click", ".swatch-list-navbar-jtpl .swatch-navbar_varaint-jtpl", function() {
  var $this_1 = $(this);
  
  var variantPrice = $this_1.find("input").attr("data-variant-price");
  var variantImage = $this_1.find("input").attr("data-variant-image");
   $this_1
      .parents(".table-row-jtpl")
      .find(".variant-price-jtpl")
      .html(variantPrice);
    $this_1
      .parents(".table-row-jtpl")
      .find("img")
      .attr("srcset", variantImage);
  
  // $('.swatch-list-navbar-jtpl .swatch-navbar_varaint-jtpl').removeClass('variant_list_active');
  $this_1.closest('.swatch-list-color-wrapper').find('li').removeClass('variant_list_active');
   var variant_main = $('.navbarhighlights__previews-jtpl .selected-swatch-navbar').find('ul.swatch-selected-color-navbar').removeClass('ul-active');
  $this_1.closest('li').addClass('variant_list_active');
  
  var variant_title = $this_1.parents(".table-row-jtpl").find(".swatch-navbar_varaint-jtpl.variant_list_active .swatch-color-title-jtpl").html();
  $this_1
    .parents(".table-row-jtpl")
    .find(".form__label-info")
    .html(variant_title);

  var htmlContent = $this_1.html();
  $this_1.closest('.swatch-grid-color-wrapper-main').find('.selected-swatch-navbar .swatch-selected-color-navbar li').html(htmlContent);
  
  var variant_swatch = $this_1.closest('.swatch-grid-color-wrapper-main').find('.swatch-list-navbar-jtpl');
  variant_swatch.removeClass('variant_active');
  var variant_main = $('.navbarhighlights__previews-jtpl .selected-swatch-navbar').find('ul.swatch-selected-color-navbar').removeClass('ul-active');
});

//----------------------------------- Function To Add the Product in the cart 
function add_to_cart(variant_id, default_id, quantity) {
  if (!variant_id && default_id) {
    variant_id = default_id;
  }
  var page_title = parseInt($('.page-title-jtpl').attr('page-title-jtpl'));
  var properties = {};
  if (!isNaN(page_title) && page_title >= 6 && page_title <= 10) {
    properties[`top ${page_title} products`] = true;
  } else {
    properties = { "top products": true };
  }
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: variant_id,
      quantity: quantity,
      properties : properties
    },
    dataType: "json",
    success: function (data) {
      updateCart();
      $('body').addClass('mini-cart--open'); 
      $('.header-wrapper').find('.cart-drawer-container').addClass('menu-opening').attr('open', 'open');
      console.log("variant_id" + data);
    },
    error: function (xhr, status, error) {
      console.error("Error Status:", status);
      console.error("Error Thrown:", error);
      console.log("Response:", xhr.responseText);
    },
  });
}
$('body').on('click', '.navbarhighlights__preview-jtpl .table-row-jtpl .atc-top5-highlights', function() {
  var $this = $(this); 
  var $row = $this.closest('.table-row-jtpl'); 
  var variant_id = $row.find('.swatch-list-style-only.navbar-highlights .swatch-grid-color-wrapper-main .selected-swatch-navbar input').attr("data-variant-jtpl");
  var default_id = $this.attr('default-id');
  if (!variant_id){
    console.log('Default_id: ' + default_id);
    variant_id = default_id;
  }
  console.log("variant_id: " + variant_id);
  var quantity = 1; 
  add_to_cart(variant_id, default_id, quantity);
});

//------------------------------------Function To Add the Products in the Bulk 
function add_bulk_to_cart(variants) {
    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
            items: variants
        },
        dataType: "json",
        success: function (data) {
            updateCart();
            $('body').addClass('mini-cart--open');
            $('.header-wrapper').find('.cart-drawer-container').addClass('menu-opening').attr('open', 'open');
            console.log("Products added to cart:", data);
        },
        error: function (xhr, status, error) {
            console.error("Error Status:", status);
            console.error("Error Thrown:", error);
            console.log("Response:", xhr.responseText);
        },
    });
}

$('body').on('click', '.table-highlights-grid-jtpl .table-row-jtpl .addbundle-pro-jtpl', function() {
    var variants = [];
    var $this = $(this);
  
    var page_title = parseInt($('.page-title-jtpl').attr('page-title-jtpl'));
    var properties = {};
  
    if (!isNaN(page_title) && page_title >= 6 && page_title <= 10) {
        properties[`top ${page_title} products`] = true;
    } else {
        properties = { "top products": true };
    }
  
    $this.parents(".table-highlights-grid-jtpl").find('.swatch-list-style-only.navbar-highlights .swatch-selected-color-navbar').each(function() {
        var selectedVariant = $(this).find("input").attr('data-variant-jtpl');
        
        if (selectedVariant) {
            variants.push({
                id: selectedVariant,
                quantity: 1 , properties : properties
            });
        }
    });

    $this.parents(".table-highlights-grid-jtpl").find('.atc-btn.atc-top5-highlights').each(function() {
        var page_title = parseInt($('.page-title-jtpl').attr('page-title-jtpl'));
        var properties = {};
      
        if (!isNaN(page_title) && page_title >= 6 && page_title <= 10) {
          properties[`top ${page_title} products`] = true;
        } else {
          properties = { "top products": true };
        }
        var selectedVariant = $(this).attr('default-id');
        
        if (selectedVariant) {
            variants.push({
                id: selectedVariant,
                quantity: 1 , properties : properties
            });
        }
    });

    console.log(variants);
    if (variants.length > 0) {
        add_bulk_to_cart(variants);
    } 
});

